import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import {URL_IMG} from '../../configs/urlConfigs';
import {titleCase} from '../../utils/changeCase'; 
import {setStorage} from '../../utils/browserStorage';
import {checkPermissions} from '../../utils/permissions';
import {getSortClass,converDateToLocal} from '../../utils/commonUtilities';
import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import {formValid,validateEmail,csvFileCheck} from '../../utils/validation';

import { ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, ROUTE_AFFILIATE_CLIENT_PROFILE, PAGENUMROWS_AFFILIATE, PAGING_END_INDEX, ROUTE_CLIENT_PROFILE, ROUTE_LOGIN_AS, LOGIN_SUPER_ADMIN_GROUP, LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, ROUTE_AFFILIATE_EVENTS, CLIENT_EMAILS_MUTED, AFFILIATE_ALL_CLIENTS_EMAILS_MUTED } from '../../configs/staticConfigs'; // IMPORT_CLIENT_CSV_FILE_NAME
import { MSG_NO_VERIFICATION_CLIENT_ADD_SUCCESS,MSG_FOLLOWING_COMPANY_INVALID_PRIMARY_CONTACT,MSG_FOLLOWING_COMPANY_ALREADY_EXISTS,MSG_CATEGORY_MANDATORY_FIELD_MISSING, MSG_DEACTIVATED,MSG_ACTIVATED,MSG_CLIENT_DELETE,MSG_CLIENT_DEACTIVATED,MSG_ERROR, MSG_REQUIRED, MSG_CLIENT_ADD_SUCCESS, MSG_NOT_FOUND, MSG_FILE_FORMAT_ERROR, MSG_FILE_NAME_ERROR, MSG_COMPANY_NAME_ADD_EDIT_DUPLICATE, MSG_CLIENT_IMPORT_SUCCESS, MSG_EMAIL_DUPLICATION,MSG_CLIENT_ACTIVATED,MSG_DELETED,MSG_MAIL_RESEND, MSG_MAIL_RESEND_ERROR, MSG_FILE_NAME_STRAT_WITH, MSG_FOLLOWING_COMPANY_INVALID_CLIENT_DETAILS, 
MSG_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED, MSG_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED} from '../../configs/msgConfigs';
import { LBL_DELETED_CONFIRM,LBL_APP_NAME, LBL_CLIENT, LBL_CLIENTS, LBL_LOGIN_AS_THIS_USER, LBL_EDIT, LBL_FILTER, LBL_ADD_NEW, LBL_CONTACT_PERSON, LBL_EMAIL, LBL_MOBILE_NUMBER, LBL_DATE_OF_JOIN, LBL_QUICK_ADD, LBL_CSV_IMPORT, LBL_SLNUM, LBL_CLEAR_FILTERS,LBL_RESEND_EMAIL, LBL_AFFILIATES, LBL_CSV_IMPORT_QUICKFILE } from '../../configs/labelConfigs'; // LBL_CONFIRM_DELETE

import * as types from '../../actions';
import {clearAction, serverTimeAction,resendEmailAction} from '../../actions/commonActions';
import {aflt_departmentsListAction} from '../../actions/settings/affiliates/aflt_departmentActions';
import {clientListAction, clientActiveDeactiveAction, clientQuickAddAction, clientImportAction, clientListSetSliderClientId,clientCategoryList, clientImportQuickFileAction} from '../../actions/clientActions';
import { eventPopupIdSetAction } from '../../actions/eventActions';

import ModalWindow from '../commons/helpers/modalWindow';
import Paginator from '../commons/helpers/paginator';
import Toast from '../commons/helpers/toast';
import Filter from '../commons/helpers/filterBy';
import FilterClient from './filterClient';
import QuickAdd from './quickAdd';
import ClientProfileComponent from './clientProfileSliderComponent';

let width = String(Number(window.innerWidth*.80)); 

class ClientListComponent extends Component {

   constructor(props){
      super()

      this.state = {
         activePage:1,
         startIndex : 0, 
         endIndex : PAGING_END_INDEX,
         activeRowId:0,    
         perPageCount:PAGENUMROWS_AFFILIATE,
         sortField:'-id',
         sortOrder:'',  
         isFilterOn: false,
         clientId:'',   
         clientName:'', 
         toastMessage:'',
         toastFlag:false,
         toastSuccess:true, 
         searchClient:'',
         formErrors:{
            companyName: '',  
            firstName:'',
            lastName:'',
            contactNumber:'',
            emailAddress:'',
            category: MSG_REQUIRED,
            departments: '',
         }, 
         quickData:{
            companyName: null,  
            websiteUrl:'',          
            firstName:null,
            lastName:null,
            contactNumber:null,
            emailAddress:null,
            position:'',
            category: null,
            sendEmailVerification: false,
            departments: [],  
         },
         isSuperAdmin:false,
         filterClicked: 0,
         resetFilterClicked: 0,
         applyFilterClicked: 0,
         applyFilter: 0,
         filtersData: {},   
         activeClientId: 0,
         addNewButtonClicked: 0,
         clientCategoryBasicData: [],
         clientCategoryAPICalled: 0,   
         activeCategoryId: 0, 
         defaultCategoryId: 0,
         defaultStartDate:'',
         defaultEndDate:'',
         departmentsList:[],
         deptMultiSelList: [], 
      }

      this.openModal           = this.openModal.bind(this);
      this.onHandleChange      = this.onHandleChange.bind(this);
      this.onShowActionButtons = this.onShowActionButtons.bind(this);
      this.onHideActionButtons = this.onHideActionButtons.bind(this);

      this.modal = React.createRef(); 
      this.csvUploader = React.createRef();
      this.csvUploaderQuickFile = React.createRef();
      
   }

   loadMultiSelDeptValues() {
      let allDept = []; 
      if(this.state.departmentsList.length > 0) {
         let tmpObj = {}; 
         let len = this.state.departmentsList.length; 
         let deptId = 0;  
         this.state.departmentsList.forEach((item,index) => { 
             if(len===1) {
                 tmpObj = {value:item.id, label:titleCase(item.name), inputVal:item.id}; 
                 deptId = item.id;   
             }
             else {
                 tmpObj = {value:item.id, label:titleCase(item.name)}; 
             }
            allDept.push(tmpObj); 
         }) 
         
          if(len===1 && deptId > 0) {
              let actUserData = this.state.quickData; 
              actUserData.departments = [deptId]; 
              let formErrors = this.state.formErrors; 
              formErrors.departments = '';  
              this.setState({quickData:actUserData,deptMultiSelList:allDept,formErrors}); 
          }
          else {
              this.setState({deptMultiSelList:allDept}); 
          }
      }
   }

   handleChangeMultiSel = (selectedDepts) =>{
      let actUserDept = []; 
      selectedDepts.forEach((item) => {
         actUserDept.push(item.value);
      });
      let actUserData = this.state.quickData; 
      actUserData.departments = actUserDept; 

      let formErrors = this.state.formErrors; // department  
      actUserData.departments = actUserDept; 
      formErrors.departments = actUserDept.length===0 ? MSG_REQUIRED : ''; 
      this.setState({quickData:actUserData,formErrors}); 
  }

   resendEmail =(userId)=>{
      this.props.resendEmailAction(userId);
   }

   callClientCategoryList = () => {
      if(this.state.clientCategoryAPICalled===0) {
         this.props.clientCategoryList(); 
      }
   }

   setActiveClientId = (client_id) =>{
    this.setState({activeClientId:client_id});
    this.showClientDetails('',client_id);
   }

   onApplyFilterButton = () => {
      let applyFilterClicked = this.state.applyFilterClicked+1; 
      this.setState({applyFilterClicked}); 
   }

   applyFilters = (filtersData) => {
      // RESET ALL LISTING VALUES TO DEFAULT AND ADD FILTER FLAG AND FILTER DATA 
      let filterApplied = 0; 
      if(filtersData.filtersSelected > 0) filterApplied = 1; 
      let sortOrder = ''; 
      let sortField = '-id'; 
      this.setState({activePage:1, sortOrder:sortOrder, sortField:sortField, applyFilter:filterApplied, filtersData:filtersData}, () => { 
         this.callClientListAction(); 
      }); 
   }

   callClientListAction = () => {
      this.props.clientListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchClient),filterApplied:this.state.applyFilter,filtersData:this.state.filtersData}); 
   }

   onResetFiltersButton = () => {   
      let resetFilterClicked = this.state.resetFilterClicked+1; 
      if(this.state.applyFilter > 0) {
          this.setState({resetFilterClicked,applyFilter:0,activePage:1, sortOrder:'', sortField:'-id'}, () => {
              this.callClientListAction(); 
              
              if(this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.add('active');   
              }
              else if(!this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.remove('active');   
              }
          });
      }
      else {
          this.setState({resetFilterClicked,applyFilter:0}); 
      }
   }

   onHandleChange = (e) =>{

      const {name,value,checked}  = e.target;
      
      let formErrors      = this.state.formErrors;

      switch(name){
         case 'companyName':
            formErrors.companyName = 
            value.length <=0 
            ? MSG_REQUIRED
            : ""
            break;  
         // case 'websiteUrl':
         //    // formErrors.websiteUrl = 
         //    // value.length <=0 
         //    // ? MSG_REQUIRED
         //    // : ""
         //    break;   
         case 'firstName':
            formErrors.firstName = 
            value.length <=0 
            ? MSG_REQUIRED
            : ""
            break;   
         case 'lastName':
            formErrors.lastName = 
            value.length <=0 
            ? MSG_REQUIRED
            : ""
            break;     
         case 'contactNumber':
            formErrors.contactNumber = 
            value.length <=0 
            ? MSG_REQUIRED
            : ""
            break;        
         case 'emailAddress':
            formErrors.emailAddress = 
            value.length <=0 || validateEmail(value) === false
            ? MSG_REQUIRED
            : ""
            break;  
         case 'category':
            formErrors.category =  value==="0"  ? MSG_REQUIRED : ""
            break; 
            
         default :
         break;
      }

      let quickData   = this.state.quickData;
      if(name === 'sendEmailVerification'){
        quickData[name] = checked;
      }else{
        quickData[name] = value;
      }
      this.setState({formErrors,quickData});
   }

   onHandleCsvImport = (e) =>{
      e.preventDefault();
      this.csvUploader.current.click();
   }
  
   onHandleCSVChange = (e) =>{   
      const value = e.target.type === "file" ? e.target.files[0] : e.target.value; 
      if(e.target.type=== "file"){
      // if(!e.target.files[0].name.startsWith(IMPORT_CLIENT_CSV_FILE_NAME.split(".csv")[0])){
         //   this.setToasterState(true,`${MSG_FILE_NAME_ERROR} ${MSG_FILE_NAME_STRAT_WITH} "${IMPORT_CLIENT_CSV_FILE_NAME.split(".csv")[0]}"`,false);
         // }else
         if(csvFileCheck(e.target.files[0].name)){
            const data = new FormData(); 
            data.append('file', value);            
            data.append('group', 4);            
            this.props.clientImportAction(data);
         }else{
            this.setToasterState(true,MSG_FILE_FORMAT_ERROR,false);
         }         
      }
   }

   onHandleCsvImportQuickFile = (e) =>{
      e.preventDefault();
      this.csvUploaderQuickFile.current.click();
   }

   onHandleCSVChangeQuickFile = (e) =>{   
      const value = e.target.type === "file" ? e.target.files[0] : e.target.value; 
      if(e.target.type=== "file"){
         if(csvFileCheck(e.target.files[0].name)){
            const data = new FormData(); 
            data.append('file', value);            
            data.append('group', 4);            
            this.props.clientImportQuickFileAction(data);
         }else{
            this.setToasterState(true,MSG_FILE_FORMAT_ERROR,false);
         }         
      }
   }

   onShowFilterBy = () => {
      let filterClicked = (this.state.filterClicked+1);
      this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked }));
      document.getElementById("filterByMenu").classList.toggle('active');
      document.getElementById("filterIcon").classList.toggle('active');
      let filterByMenu = document.getElementById('filterByMenu');    
      let quoteTab = document.getElementById('detailTab');
      let filterTab = document.getElementById('filterTab');
      filterTab.style.display     = 'block';   
      quoteTab.style.display      = 'none';   
      if(this.state.isFilterOn){
            filterByMenu.style.width='580px';
            filterByMenu.style.right='-580px';
      }else{
            filterByMenu.style.width='580px';
            filterByMenu.style.right='0';
      }
   }

   // onCloseSlider = () => {
   //    let filterByMenu = document.getElementById('filterByMenu');  
   //    let quoteTab = document.getElementById('detailTab');
   //    // let filterTab = document.getElementById('filterTab');
   //    quoteTab.style.display = 'block';    
   //    // filterTab.style.display = 'none';
   //    filterByMenu.style.width='1000px';
   //    filterByMenu.style.right='-1000px';
   // }

   onShowActionButtons = (event, rowId) =>{

      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.toggle('show');
      dropdownMenu.classList.toggle('show');      

      if(this.state.activeRowId===0){   
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      }else if(this.state.activeRowId===rowId){ 
         this.setState({activeRowId:0}); 
      }else if(this.state.activeRowId!==rowId){   
         dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
         dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
         dropdown.classList.toggle('show');
         dropdownMenu.classList.toggle('show');
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      } 
   }    

   onHideActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
      this.setState({activeRowId:0});
   }

   openModal() {
      this.resetFormErrors();
      this.callClientCategoryList(); 
      this.props.aflt_departmentsListAction({associated:'1'});
      this.modal.current.handleOpenModal();
   }  

   // deleteBtnClick = (rowId,name) =>{
   //    this.setState({
   //       clientId:rowId,
   //       clientName:name          
   //    }); 
   //    this.modalDelete.current.handleOpenModal();
   // }

   // onDeleteAction = () =>{
   //    let clientId = this.state.clientId;
   //    let data = {
   //       active:false,
   //       profileId:clientId
   //    }
   //    this.props.clientActiveDeactiveAction(data);
   //    this.modalDelete.current.handleModelClose();                    
   // } 

   resetFormErrors=()=>{
      let formErrors = this.state.formErrors;
      formErrors.companyName = "";
      // formErrors.websiteUrl = '';
      formErrors.firstName = "";
      formErrors.lastName = "";
      formErrors.contactNumber = ""; 
      formErrors.emailAddress = "";
      formErrors.category = "";
      formErrors.departments = "";
      this.setState({formErrors});
   }

   onSaveFormData = (e) =>{
      if(formValid(this.state)){
         let quickData= {
            company_name: this.state.quickData.companyName,
            web_site: this.state.quickData.websiteUrl,
            first_name:this.state.quickData.firstName,
            last_name: this.state.quickData.lastName,
            email: this.state.quickData.emailAddress,
            contact_number:this.state.quickData.contactNumber,
            position:this.state.quickData.position,    
            category:this.state.quickData.category,     
            departments:JSON.stringify(this.state.quickData.departments),   
            send_email_verification:this.state.quickData.sendEmailVerification     
         }
         this.props.clientQuickAddAction(quickData);
      }else{
         let formErrors = this.state.formErrors;
         if(this.state.quickData.companyName==null){
               formErrors.companyName = MSG_REQUIRED;
         } 
         // if(this.state.quickData.websiteUrl==null){
         //       // formErrors.websiteUrl = MSG_REQUIRED;
         // } 
         if(this.state.quickData.firstName==null){
            formErrors.firstName = MSG_REQUIRED;
         } 
         if(this.state.quickData.lastName==null){
               formErrors.lastName = MSG_REQUIRED;
         } 
         if(this.state.quickData.emailAddress==null){
            formErrors.emailAddress = MSG_REQUIRED;
         }  
         if(this.state.quickData.category==null){
            formErrors.category = MSG_REQUIRED;
         }
         if(this.state.quickData.contactNumber==null){
               formErrors.contactNumber = MSG_REQUIRED;
         } 
         if(this.state.quickData.departments==null||this.state.quickData.departments.length<=0){
            formErrors.departments = MSG_REQUIRED;
         }       
         this.setState({formErrors});
      }
   }

   onModalFormReset = () =>{       
      this.setState({
         clientId:'',
         quickData:{
            companyName: null,  
            websiteUrl:'',          
            firstName:null,
            lastName:null,
            contactNumber:null,
            emailAddress:null,
            position:'', 
            category: null,
            sendEmailVerification:false
         }        
      }); 
   }
   
   onPagePrevious = (e) =>{
      const {
          startIndex, endIndex        
      } = this.state
      let previousPage = startIndex+1-PAGING_END_INDEX
      
      if(startIndex===0){
          this.setState({
              activePage: previousPage,
              startIndex : startIndex,
              endIndex : endIndex
          }, () => {
            this.callClientListAction(); 
          });  
      }else{
          this.setState({
              activePage: previousPage,
              startIndex : startIndex - PAGING_END_INDEX,
              endIndex : endIndex - PAGING_END_INDEX
          }, () => {
            this.callClientListAction(); 
          });  
      }                           
   }

   onPageUp = (e) => {  

      this.props.clientListAction({pageSize:this.state.perPageCount,page:e.target.id,column:this.state.sortOrder+this.state.sortField,search:this.state.searchClient,filterApplied:this.state.applyFilter,filtersData:this.state.filtersData});
 
      this.setState({activePage: Number(e.target.id)}, () => {
         this.callClientListAction(); 
       });
   }

   onPageNext = (e) =>{   
      const {
          startIndex,endIndex            
      } = this.state     
      const {
          totalPage            
      } = this.props
             
      let nextPage = startIndex+1+PAGING_END_INDEX;
      
      if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
          this.setState({
              activePage: nextPage,
              startIndex : startIndex,
              endIndex : endIndex
          }, () => {
            this.callClientListAction(); 
          }); 
      }else{
          this.setState({
              activePage: nextPage,
              startIndex : startIndex + PAGING_END_INDEX,
              endIndex : endIndex + PAGING_END_INDEX
          }, () => {
            this.callClientListAction(); 
          });  
      }                                   
   }

   onSort = (event,sortKey) =>{        
      let sOrder = '';
      if(this.state.sortField===sortKey){         
          sOrder = (this.state.sortOrder==='-') ? '' : '-';
          this.setState({ sortOrder:sOrder }, () => {
            this.callClientListAction(); 
          });            
      }else{
          this.setState({ sortField:sortKey }, () => {
            this.callClientListAction(); 
          });
      }        
   }
   setAddnewButtonClickedToZero = () =>{
    this.setState({addNewButtonClicked:0});
   }

   showClientDetails(e,id) { 
      this.callClientCategoryList(); 
      let addNewButtonClicked = this.state.addNewButtonClicked; 
      if(id===0) addNewButtonClicked++; 
      if(this.state.isFilterOn){
          this.inputFilter.click();
      }
      this.setState({activeClientId:id, addNewButtonClicked:addNewButtonClicked}, () => {
         document.getElementById("filterByMenu").classList.toggle('active');    
         let filterByMenu = document.getElementById('filterByMenu');  
         let quoteTab = document.getElementById('detailTab');
         let filterTab = document.getElementById('filterTab');
         quoteTab.style.display  = 'block';    
         filterTab.style.display = 'none';
         filterByMenu.style.width=width+'px';
         filterByMenu.style.right='0';
      }); 
   }

   goToClientProfile(e,id) {
      let {isSuperAdmin} = this.state;
      let profileId = '';
      if(id){
         profileId = id;
      }
      if(isSuperAdmin){
         this.props.history.push(ROUTE_CLIENT_PROFILE+'/'+profileId);
      }else{
         this.props.history.push(ROUTE_AFFILIATE_CLIENT_PROFILE+'/'+profileId);
      }
   }

   redirectToEventsFromClientList = (eventId) => { 
      if(eventId && parseInt(eventId,10)) {
         this.props.eventPopupIdSetAction(eventId); 
         this.props.history.push(ROUTE_AFFILIATE_EVENTS); //+'/'+eventId
      }
   }

   onCloseToast = () =>{
      this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
   } 

   onSearchClient = (e)=>{
      let strVal = e.target.value; 
      this.setState({searchClient:strVal,activePage:1}, () => { 
         if(strVal.length >=3 || strVal.length===0) {
            this.callClientListAction(); 
         }
      }); 
   }

   setToasterState(isEnabled,message,isSucces,isAutoHide=true,delay=5000){
      this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
      if(isAutoHide){
          setTimeout(()=> {
              this.onCloseToast();
          }, delay);
      }    
  }

  onPhoneInputChange = (value, data, event, formattedValue) =>{
        let quickData   = this.state.quickData;     
        let formErrors   = this.state.formErrors;     
        quickData['contactNumber'] = formattedValue;
        formErrors.contactNumber = value.trim()===data.dialCode ? MSG_REQUIRED : ""
        formErrors.contactNumber = formattedValue.trim().length<5 ? MSG_REQUIRED : ""

        this.setState({formErrors,quickData});
    }

   setStateUpdate(numRows,totalPage,activity,errorData,status,clientId){
      let formErrors = this.state.formErrors;
      const {sliderClientId} = this.props;
      if(status===200 && activity===types.CLIENT_LIST_SUCCESS && sliderClientId && Number(sliderClientId) > 0 && Number(this.state.activeCrewId)!==Number(sliderClientId)){            
         this.props.clientListSetSliderClientId(0); 
         this.showClientDetails('',Number(sliderClientId)); 
      }
      else if(activity===types.CLIENT_QUICK_ADD_SUCCESS){
         this.modal.current.handleModelClose();
         this.callClientListAction();
         if(this.props.quickResponse.verification_email_send){
            this.setToasterState(true,MSG_CLIENT_ADD_SUCCESS,true,false);
         }else{
            this.setToasterState(true,MSG_NO_VERIFICATION_CLIENT_ADD_SUCCESS,true,false);  
         } 
              
      }else if(activity===types.CLIENT_QUICK_ADD_ERROR){      
            if(status===400){
               if(errorData.hasOwnProperty('company_name')){
                  formErrors.companyName = errorData.company_name[0];
               }else if(errorData.hasOwnProperty('email')){
                  formErrors.emailAddress = errorData.email[0];
               }else{
                  this.setToasterState(true,JSON.stringify(errorData),false);
               }                       
               this.setState(formErrors);
            }else{
               this.modal.current.handleModelClose();
               if(errorData.hasOwnProperty('message')){ 
                  this.setToasterState(true,errorData.message,false);
               }else{
                  this.setToasterState(true,JSON.stringify(errorData),false);
               }
            }
            
      }else if(activity===types.CLIENT_ACTIVE_DEACTIVE_SUCCESS){
         if (numRows===1 && totalPage > 1){
            let page = this.state.activePage-1;
            this.callClientListAction(); 
        }else{
            this.callClientListAction(); 
        }
        let msg = MSG_CLIENT_DEACTIVATED;
        if(this.props.activeStatus === LBL_DELETED_CONFIRM){
            msg = MSG_CLIENT_DELETE;
        } 
        else if(this.props.activeStatus){
            msg = MSG_CLIENT_ACTIVATED;
        }    
        this.setToasterState(true,msg,true);   
      }else if(activity===types.CLIENT_ACTIVE_DEACTIVE_ERROR){
         this.setToasterState(true,MSG_ERROR,false); 
      }
      else if(activity===types.CLIENT_IMPORT_SUCCESS){
          if (numRows===1 && totalPage > 1){
            let page = this.state.activePage-1;
            this.callClientListAction(); 
          }else{
            this.callClientListAction(); 
          }
          let message = "";
          if(clientId.existing_company_names !==undefined && clientId.existing_company_names.length>0){
            message += MSG_COMPANY_NAME_ADD_EDIT_DUPLICATE +" "
            message += clientId.existing_company_names.join(',\n\t ')
          }if(clientId.existing_email !==undefined && clientId.existing_email.length>0){
            if(message.length>0){
               message += "<p>   </p>"
            }
            message += MSG_EMAIL_DUPLICATION + " "
            message += clientId.existing_email.join(',\n\t ')
          }if(clientId.category_field_missing !==undefined && clientId.category_field_missing.length>0){
            if(message.length>0){
               message += "<p>   </p>"
            }
            message += MSG_CATEGORY_MANDATORY_FIELD_MISSING + " "
            message += clientId.category_field_missing.join(',\n\t ')
          }if(clientId.existing_imported !==undefined && clientId.existing_imported.length>0){
            if(message.length>0){
               message += "<p>   </p>"
            }
            message += MSG_FOLLOWING_COMPANY_ALREADY_EXISTS + " "
            message += clientId.existing_imported.join(',\n\t')
          }if(clientId.invalid_contact_details !== undefined && clientId.invalid_contact_details.length>0){
            if(message.length>0){
               message += "<p>   </p>"
            }
            message += MSG_FOLLOWING_COMPANY_INVALID_PRIMARY_CONTACT + " "
            message += clientId.invalid_contact_details.join(',\n\t ')
          }if(clientId.invalid_client_details !== undefined && clientId.invalid_client_details.length>0){
            if(message.length>0){
               message += "<p>   </p>"
            }
            message += MSG_FOLLOWING_COMPANY_INVALID_CLIENT_DETAILS + " "
            message += clientId.invalid_client_details.join(',\n\t ')
          }if(message.length===0){
            let message = MSG_CLIENT_IMPORT_SUCCESS
            this.setToasterState(true,message,true);
          }else{
            this.setToasterState(true,message,false,false,8000);
          }
          document.getElementsByName("csvFile")[0].value = "";

      }else if(activity===types.CLIENT_IMPORT_ERROR){
        //let message = "";
        if("message" in errorData){
            this.setToasterState(true,errorData.message,false,false); 
         }else{
            this.setToasterState(true,JSON.stringify(errorData),false,false); 
         }
         document.getElementsByName("csvFile")[0].value = ""; 
      }   
      else if(activity===types.CLIENT_IMPORT_QUICK_FILE_SUCCESS){
         this.callClientListAction(); 
         this.setToasterState(true,MSG_CLIENT_IMPORT_SUCCESS,true);
         document.getElementsByName("csvFileQuickFile")[0].value = "";
      }else if(activity===types.CLIENT_IMPORT_QUICK_FILE_ERROR){
        if("msg" in errorData){
            this.setToasterState(true,errorData.msg,false,false); 
         }else{
            this.setToasterState(true,JSON.stringify(errorData),false,false); 
         }
         document.getElementsByName("csvFileQuickFile")[0].value = "";
      } 
   } 

   onLoginAs = (e,id,name) =>  {
      let userGroupData = userGroupUrlCheck(this.props.location);
      let userId = 0; 
      if(userGroupData!==undefined){
         userId = userGroupData.user_id; // associate_id
      }

      let dataObj = {loginAs:LOGIN_CLIENT_GROUP,profileId:id,profileName:name,saUserId:userId}; 
      //this.props.loginAsAction(dataObj); 
      setStorage('saLoginAsData', JSON.stringify(dataObj));
      window.open(ROUTE_LOGIN_AS, "_blank") //to open new page
   }

   componentDidUpdate(prevProps) {
      const {isFilterOn,numRows,totalPage,activity,errorData,status,clientId,clientProfActivity,clientCategoryData, crewProfileActivity} = this.props;   
      
      if (isFilterOn !== prevProps.isFilterOn) {
         this.inputFilter.click();   
      }else if (activity !== prevProps.activity) {
         this.setStateUpdate(numRows,totalPage,activity,errorData,status,clientId);
         this.props.clearAction();
      }
      if(this.props.serverTimeListActivity && this.props.serverTimeListActivity !== prevProps.serverTimeListActivity){
            let arrTimeResp = this.props.serverTimeListActivity.split('~~');
            if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
               // let defaultEndDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
               let defaultEndDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                this.setState({defaultStartDate:defaultEndDate,defaultEndDate:defaultEndDate})
            }
      } 
      
      if(clientProfActivity && clientProfActivity.length && clientProfActivity != prevProps.clientProfActivity) {
         let arrTemp = clientProfActivity.split('~~'); 
         let actString = arrTemp[0]; 

         if(actString===types.RESEND_EMAIL_SUCCESS){ 
            this.setToasterState(true,MSG_MAIL_RESEND,true,false);
         }else if(actString===types.RESEND_EMAIL_ERROR){
            let sendErrMsg = MSG_MAIL_RESEND_ERROR; 
            if (errorData?.message) { 
               sendErrMsg = errorData.message===CLIENT_EMAILS_MUTED ? MSG_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED : 
               errorData.message===AFFILIATE_ALL_CLIENTS_EMAILS_MUTED ? MSG_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED : 
               MSG_MAIL_RESEND_ERROR;
            } 
            this.setToasterState(true,sendErrMsg,false); 
         }

         if(actString===types.PROFILE_CLIENT_CATEGORY_LIST_SUCCESS){
            this.setState({clientCategoryBasicData:clientCategoryData}); 
         }
      }
      
      if (crewProfileActivity && crewProfileActivity !== prevProps.crewProfileActivity) { 
         let arrRespDept = crewProfileActivity.split('~~'); 
         let actStringDept = arrRespDept[0];

         if(actStringDept===types.DEPARTMENT_LIST_AFFILIATE_SUCCESS){
             if(this.props.hasOwnProperty('afltDepartmentsForCrew')) {
                 if(this.props.afltDepartmentsForCrew.length===0) {
                       this.setState({departmentsList: []}, () => {
                          this.loadMultiSelDeptValues(); 
                       } ); 
                 }
                 else {     
                       this.setState({departmentsList: this.props.afltDepartmentsForCrew}, () => {
                          this.loadMultiSelDeptValues(); 
                       } );                  
                 }
             }
         }
      }
   }

   componentDidMount() {
      const { location } = this.props;
      if(location.state!==undefined && location.state.hasOwnProperty('clientName')){ // to show success message after deactivate
         let msg = MSG_DEACTIVATED;
         if(this.props.activeStatus === true){
          msg = MSG_ACTIVATED;
         }else if(this.props.activeStatus === 'deleted'){
          msg = MSG_DELETED;
         }
         this.setToasterState(true,LBL_CLIENT+' '+location.state.clientName+' '+msg,true); 
         window.history.pushState(null, '');
      }
      let userGroupData = userGroupUrlCheck(location);
      let userGroup = ''; 
      if(userGroupData!==undefined){
         userGroup = userGroupData.user_group; 
      }   
      if(userGroup===LOGIN_AFFILIATE_GROUP){
         document.body.classList.add('body-affiliate'); 
         this.setState({isSuperAdmin:false});
      }else{
         document.body.classList.add('body-super');
         this.setState({isSuperAdmin:true});
      }
      document.title = LBL_APP_NAME+" - "+LBL_CLIENTS;
      this.props.serverTimeAction();
      this.callClientListAction(); 
   }
   
    render(){

        const {
         activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,isSuperAdmin,sortField,sortOrder,           
        } = this.state  

        const { clients,totalPage,status} = this.props;  

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        if(status===401 || status===403){ 
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;
            }
        }
        
        let isAddClient = checkPermissions("client","modify"); 
        let isLoginAs = checkPermissions("loginas","view"); 
        return(
            <React.Fragment>
            <div className="col-md-12">
               <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
               
               <div className="box">
                  <div className="box-head">
                     <div className="dataTables_filter"><label>
                        <input type="search" className="" placeholder={LBL_CLIENT+'/'+LBL_CONTACT_PERSON+'/'+LBL_EMAIL+'/'+LBL_MOBILE_NUMBER} id="my-search-input" onChange={this.onSearchClient} />
                        </label>
                     </div>
                     <div className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'}>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 450, hide: 250 }}
                            overlay={<Tooltip id="filterIcon-tooltip" style={{
                                opacity: 0.4,
                              }}>
                            {LBL_FILTER}
                          </Tooltip>}
                        >
                            <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter padding-5 ':'filter-btn  text-primary padding-5 '}><i className="las la-filter"></i></button>
                            
                        </OverlayTrigger>
                        
                     </div>

                     {this.state.applyFilter > 0 && 
                        <div className="text-12 div150" >&nbsp; &nbsp; <Link to="#" onClick={this.onResetFiltersButton} >{LBL_CLEAR_FILTERS}</Link></div>} 

                     { !isSuperAdmin && isAddClient &&
                     <>
                     <div className="to-right padding-right-15">
                        <button onClick={this.openModal} className="btn btn-primary launch-modal">{LBL_QUICK_ADD}</button>
                     </div>
                     <div className="to-right">
                        {/* <Link to="#" className="btn btn-primary" onClick={e => this.goToClientProfile(e)} >{LBL_ADD_NEW} </Link>  */}
                        <Link to="#" className="btn btn-primary" onClick={e => this.showClientDetails(e,0)} >{LBL_ADD_NEW}  </Link>
                     </div>
                     </>  
                     }

                     { isAddClient && !isSuperAdmin && 
                        <div className="to-right filter-btn-wrapper"> 
                           <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 400 }}
                              overlay={<Tooltip id="download-tooltip" style={{
                                 opacity: 0.4,
                                 }}>{LBL_CSV_IMPORT}
                              </Tooltip>}
                              >
                                    <Link to="#" onClick={(e) => this.onHandleCsvImport(e)} className="btn btn-outline-primary filter-btn"><i className="las la-file-import"></i> </Link>                                
                                 
                           </OverlayTrigger>       
                           <input name="csvFile" type="file" accept=".csv" id="file" ref={this.csvUploader} onChange={this.onHandleCSVChange} style={{display: "none"}}/>                    
                        </div>
                     }

                     {/* Client import from Quickfile (Quickfile - application used by the client to create and send Quote) */}
                     { isAddClient && !isSuperAdmin && 
                        <div className="to-right filter-btn-wrapper"> 
                           <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 400 }}
                              overlay={<Tooltip id="download-tooltip" style={{
                                 opacity: 0.6,
                                 }}>{LBL_CSV_IMPORT_QUICKFILE}
                              </Tooltip>}
                              >
                                    <Link to="#" onClick={(e) => this.onHandleCsvImportQuickFile(e)} className="btn btn-outline-primary filter-btn "><i className="la la-file-import bgGrey"></i> </Link>                                
                                 
                           </OverlayTrigger>       
                           <input name="csvFileQuickFile" type="file" accept=".csv" id="file" ref={this.csvUploaderQuickFile} onChange={this.onHandleCSVChangeQuickFile} style={{display: "none"}}/>                    
                        </div>
                     }

                  </div>
                  <div className="box-content">
                     <div className="table-responsive">
                        <table id="data-table" className="table" style={{width:"100%"}}>
                           <thead>
                              <tr> 
                                 <th>{LBL_SLNUM}</th>
                                 <th onClick={(e) => this.onSort(e,'company_name')} className="client-name spanPointer" >{LBL_CLIENT} <i className={sortField=='company_name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'associateusers__user__first_name')} className="contact-person spanPointer">{LBL_CONTACT_PERSON} <i className={sortField=='associateusers__user__first_name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'associateusers__user__email')} className="spanPointer">{LBL_EMAIL} <i className={sortField=='associateusers__user__email' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'associateusers__phone_number')} className="mobile-number spanPointer">{LBL_MOBILE_NUMBER} <i className={sortField=='associateusers__phone_number' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th onClick={(e) => this.onSort(e,'created_on')} className="date-join spanPointer">{LBL_DATE_OF_JOIN} <i className={sortField=='created_on' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 {userGroup===LOGIN_SUPER_ADMIN_GROUP && <th className="action">{LBL_AFFILIATES}</th> }
                                 {userGroup===LOGIN_SUPER_ADMIN_GROUP && <th className="action">&nbsp;</th> }
                              </tr>
                           </thead>
                           <tbody>
                           {(clients.length===0)  && 
                              <tr>
                                    <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                              </tr>
                           }
                           { clients.map((item, index)  => {
                              let contactPersonId = '';
                              let contactPerson = '';
                              let contactNumber = '';
                              let contactEmail = '';
                              let indeNum = (PAGENUMROWS_AFFILIATE*(activePage-1))+index+1;
                              let isEmailVerified = '';
                              if(item.associateusers_set.length>0){
                                 let associateusers = item.associateusers_set.filter((user) => user != null);
                                 if(associateusers.length>0){
                                    contactPersonId = associateusers[0].user.id;
                                    contactPerson   = associateusers[0].user.first_name+' '+associateusers[0].user.last_name;
                                    contactNumber   = associateusers[0].phone_number;
                                    contactEmail    = associateusers[0].user.email;
                                    isEmailVerified = associateusers[0].email_verified===false?'Not Verified':'';
                                 }
                              }
                              let created_on = converDateToLocal(item.actual_created_on,"00:00",'ddmmyyyy');
                              
                              let clAffiliates = ''; 
                              if(Array.isArray(item.affiliate_details)) {
                                 clAffiliates = item.affiliate_details.map(clAf => {
                                    return <div>{clAf.affiliate_company_name}</div>; 
                                 })
                              }  
                                 return (
                                       <tr key={index}>
                                          <td>{indeNum}</td>
                                          {isAddClient &&
                                          <td><Link to="#" onMouseDown={(e) => this.showClientDetails(e,item.id)}>{item.company_name}</Link>
                                          <small className="block">{item.client_category.name}</small>


                                          {/*<Link to="#" onMouseDown={(e) => this.goToClientProfile(e,item.id)}>..</Link>*/}
                                          </td>
                                          }
                                          {!isAddClient &&
                                             <td><p className="mb-0">
                                             {item.company_name}</p>
                                             </td>
                                             }
                                          <td>{contactPerson}</td>
                                          <td><div>{contactEmail}</div>
                                             <div className="divFloatLeft"><small className="block text-red">{isEmailVerified}</small></div>
                                             {/* {isEmailVerified.length && <div className="divFloatRight"><small className="block">{LBL_RESEND_EMAIL}</small></div>} */}

                                             {contactPersonId > 0 && isEmailVerified.length > 0 && <Link className={'resend-btn float-right'} to="#" onClick={e => this.resendEmail(contactPersonId)}>{LBL_RESEND_EMAIL}</Link>}
                                          </td>
                                          <td>{contactNumber}</td>
                                          <td>
                                             {/* <Moment format="DD/MM/YYYY HH:mm">{item.created_on}</Moment> */}
                                             {created_on} 
                                          </td>
                                          
                                          {userGroup===LOGIN_SUPER_ADMIN_GROUP && 
                                          <td>{clAffiliates}</td>
                                          }
                                          
                                          {userGroup===LOGIN_SUPER_ADMIN_GROUP && 
                                          <td>
                                          {isAddClient && contactEmail.length > 1 && isEmailVerified==='' && isLoginAs &&  
                                          <div className="dropdown" id={'dropdown-'+item.id}>
                                             <button className="dropdown-toggle" type="button"
                                                   id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                   aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                   >
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                             </button>
                                             <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                   aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                      {userGroup===LOGIN_SUPER_ADMIN_GROUP && contactEmail.length > 1 && isEmailVerified==='' && isLoginAs && <Link className="dropdown-item" to="#" onMouseDown={(e) => this.onLoginAs(e,item.id,item.company_name)}>{LBL_LOGIN_AS_THIS_USER}</Link>}
                                                   {/*<Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.showClientDetails(e,item.id)}>{LBL_EDIT}</Link>
                                                      <Link className="dropdown-item delete"
                                                      to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.company_name)}>Delete</Link> */}
                                             </div>
                                          </div>
                                          }
                                          </td>
                                       }
                                       </tr>             
                                        
                                     )
                                  })      

                                }                      
                           </tbody>
                        </table>
                        <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                     </div>
                  </div>                    
               </div>

               {/* <ModalWindow ref="modalDelete" header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
               {"Are you sure you want to delete Client '"+this.state.clientName+"'?"}
               </ModalWindow> */}
                        
               <ModalWindow ref={this.modal} header="Basic Details" saveFormData={ (e)=>this.onSaveFormData(e)} resetModalForm={this.onModalFormReset} type="save">
                  <QuickAdd onHandleChange={(e) => this.onHandleChange(e)} onPhoneInputChange={this.onPhoneInputChange} {...this.state} sendEmail={this.state.quickData.sendEmailVerification} deptMultiSelList={this.state.deptMultiSelList} handleChangeMultiSel={this.handleChangeMultiSel} />
               </ModalWindow>          
            </div>


            <Filter isDetail={true}  onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton} needParentCallBack='yes' onFilterClose={this.onFilterClose}  >

               <FilterClient clientCategoryData={this.props.clientCategoryData} defaultStartDate={this.state.defaultStartDate} filterClicked={this.state.filterClicked} resetFilterClicked={this.state.resetFilterClicked} applyFilterClicked={this.state.applyFilterClicked} applyFilters={this.applyFilters} userGroup={userGroup} />

               {/* IF CLIENT ID NOT SET THE VALUE SHOULD BE UNDEFINED - this.props.activeClientId will be always undefined */}
               <ClientProfileComponent setAddnewButtonClickedToZero={this.setAddnewButtonClickedToZero} setActiveClientId={this.setActiveClientId} location={this.props.location} clientId={this.state.activeClientId?this.state.activeClientId:this.props.activeClientId} addNewButtonClicked={this.state.addNewButtonClicked} callCrewListAction={this.callCrewListAction} callClientListAction={this.callClientListAction} redirectToEventsFromClientList={this.redirectToEventsFromClientList}  />

            </Filter>
         </React.Fragment>
        )
    }

}
const mapStateToProps = (state) => {
      return {
         sliderClientId: state.clients.sliderClientId,
         clients: state.clients.items,
         quickResponse: state.clients.quickResponse,
         totalPage:state.clients.totalPage,
         status:state.clients.status,
         activity:state.clients.activity,
         numRows:state.clients.numRows,
         count:state.clients.count,
         errorData:state.clients.errorData,
         isFilterOn: state.commons.isFilterOn,
         clientId:state.clients.clientId,    
         activeStatus:state.clients.activeStatus,
         clientProfActivity:state.clients.clientProfActivity,
         clientCategoryData:state.clients.clientCategoryListData,
         serverTimeList: state.serverTimeList.serverTimeList,
         serverTimeListActivity : state.serverTimeList.serverTimeListActivity,
         afltDepartmentsForCrew:state.crews.afltDepartmentsForCrew,
         crewProfileActivity:state.crews.crewProfileActivity,
      }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
         clientListAction:clientListAction,
         clientQuickAddAction:data=>clientQuickAddAction(data),
         clientImportAction:data=>clientImportAction(data),
         clientImportQuickFileAction:data=>clientImportQuickFileAction(data), 
         clientActiveDeactiveAction:id=>clientActiveDeactiveAction(id),
         clearAction:clearAction,
         clientListSetSliderClientId:clientListSetSliderClientId,
         clientCategoryList:clientCategoryList,
         serverTimeAction:serverTimeAction,
         resendEmailAction:resendEmailAction, 
         aflt_departmentsListAction:aflt_departmentsListAction,
         eventPopupIdSetAction:eventPopupIdSetAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(ClientListComponent);